module.exports = __webpack_public_path__ + "img/1@2x.4feb7ea3.png";